import {
  appTypeKey,
  codeKey,
  deviceInfoMap,
  sChannel,
  sPkg,
  tokenKey,
  uuIdKey,
  version,
  realPkgTypeKey,
  authCodeKey
} from '@/constants'
import {
  createRequest,
  addEncryInterceptors,
  addDuplicateRequestInterceptor,
  addEspecialCodeReportInterceptor
} from 'web-utils/request'
import { deviceInfo, deviceInfoByWeb } from 'web-utils/device'
import { queryURLParams } from 'web-utils/url'
import { lang } from '@/locals'
import Cookies from 'js-cookie'
import {
  getAppType,
  fieldSeHandler,
  clearGuestLogin,
  isRealTgEnv,
  getBaseLoginParams,
  dealLogin,
  inNativeOrMonitorNative,
  getTgStartParams
} from '@/utils'

const env = import.meta.env.MODE

const instance = createRequest({
  baseURL: import.meta.env.VITE_API_URL
})

const refreshFun = async () => {
  if (inNativeOrMonitorNative()) {
    return
  }
  // 刷新之前清空 code, token
  clearGuestLogin()
  const baseLoginParams = await getBaseLoginParams()
  const res = await instance.post('/user/user/login', baseLoginParams)
  if (res.code == 0) {
    // 处理taurus app 跳转out页面带来的授权token
    const token = queryURLParams('token') || ''
    if (token) {
      localStorage.setItem(authCodeKey, token)
    }
    dealLogin(res.data)
  } else {
    // 刷新token失败一定要抛错误，防止工具类里面把该业务请求进行了无限的重试
    throw new Error(res.msg)
  }
}
addDuplicateRequestInterceptor(instance)
addEspecialCodeReportInterceptor(instance)
// 请求拦截器执行顺序是反方向的，先添加的后执行
addEncryInterceptors(instance, env, env != 'dev' && env != 'test', true, {
  isRefreshToken: true,
  refreshFun
})
instance.interceptors.request.use((config) => {
  let info = {
    appType: getAppType(),
    appVersion: version,
    code: localStorage.getItem(codeKey) || '',
    token: localStorage.getItem(tokenKey) || '',
    s_pkg: sPkg,
    s_channel: sChannel,
    language: lang,
    os: deviceInfoMap[deviceInfoByWeb().os],
    href: window.location.href,
    webUuid: localStorage.getItem(uuIdKey) || ''
  }
  const isRealTg = isRealTgEnv()
  if (isRealTg) {
    const { id } = window?.Telegram?.WebApp?.initDataUnsafe?.user || {}
    info.thirdUserId = String(id)
  }
  const isModifyAppType = !!window.TaurusApp?.showPwaType && window.TaurusApp?.showPwaType()
  if (inNativeOrMonitorNative() && !isModifyAppType) {
    const {
      token,
      code,
      appType,
      appVersion,
      lang: deviceLang,
      pkg,
      channel,
      gaid,
      aid,
      pkgType
    } = deviceInfo()
    info = {
      ...info,
      appType: Cookies.get('appType') || appType,
      token: Cookies.get(tokenKey) || token || localStorage.getItem(tokenKey) || null,
      code: Cookies.get('code') || code || localStorage.getItem(codeKey) || null,
      language: deviceLang || Cookies.get('language') || lang,
      appVersion: Cookies.get('appVersion') || appVersion,
      s_pkg: Cookies.get('pkg') || pkg,
      s_channel: Cookies.get('channel') || channel,
      s_gaid: Cookies.get('gaid') || gaid,
      s_android_id: Cookies.get('aid') || aid,
      pkgType: pkgType || Cookies.get('pkgType') || 'TAURUS'
    }
    Cookies.set(tokenKey, info.token || '')
    Cookies.set('appType', info.appType || '')
    Cookies.set('pkgType', info.pkgType || '')
    Cookies.set('aid', info.s_android_id || '')
    Cookies.set('language', info.language || '')
    Cookies.set('pkg', info.s_pkg || '')
    Cookies.set('channel', info.s_channel || '')
    Cookies.set('appVersion', info.appVersion || '')
    Cookies.set('code', info.code || '')
    Cookies.set('gaid', info.s_gaid || '')
  }
  if (window.location.href.includes('/devTransfer')) {
    const gaid = queryURLParams('gaid')
    info = {
      ...info,
      s_gaid: gaid?.includes('{') || gaid?.includes('gaid') || gaid?.includes('}') ? '' : gaid
    }
  }
  sessionStorage.setItem(appTypeKey, info.appType)
  let urlPkgType = queryURLParams('pkgType')
  let urlCode
  if (isRealTg) {
    const tgStartParam = getTgStartParams()
    if (tgStartParam) {
      urlPkgType = tgStartParam.pkgType
      urlCode = tgStartParam.code
    }
  }
  const isLoginRequest = config.url?.includes('/user/user/login')
  if (isLoginRequest) {
    if (urlPkgType) info.pkgType = urlPkgType
    if (urlCode) info.code = urlCode
  } else {
    const cachePkgType = localStorage.getItem(realPkgTypeKey)
    if (cachePkgType) {
      info.pkgType = cachePkgType
    }
  }
  config.headers = {
    ...config.headers,
    'X-Info': JSON.stringify(info)
  }
  return config
})
instance.interceptors.response.use(
  (res) => {
    const { code } = res || {}
    if (code === 0) {
      return fieldSeHandler(res)
    }
    return res
  },
  (err) => {
    return err?.response?.data || {}
  }
)
export default instance
